<template>
  <HeadWithLogo/>
  <div class="row">
    <span>تصویرآیکون سامانه برخط ناظریک بر روی صفحه موبایل</span><br>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/iconPic.jpg" alt="img" class="img-fluid"/>
      </div>
    </div>
    <span> بعضی از صفحات سامانه برخط ناظریک بر روی صفحه موبایل</span><br>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/loading.jpg" alt="img" class="img-fluid"/>
      </div>
    </div>
    <span>تصویر صفحه یک کاریر سامانه در حال ثبت پلاک ماشینِ کشف حجاب کرده</span><br/>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/info1.jpg" alt="img" class="img-fluid"/>
      </div>
    </div>
    <span> قسمتی از صفحه (گزارش ثبت تخلفات قبلی) یک کاربر </span><br>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/info2.png" alt="img" class="img-fluid"/>
      </div>
    </div>
    <span>نمایی از گزینه های دیگر سامانه برخط ناظر یک </span><br>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/menuList.png" alt="img" class="img-fluid"/>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-6 text-end">
      <RouterLink to="/introSecond" class="btn btn-success px-3">
        صفحه قبل
      </RouterLink>
    </div>
    <div class="col-6 text-start">
      <RouterLink to="/introFourth" class="btn btn-success px-3">
        صفحه بعد
      </RouterLink>
    </div>
  </div>
</template>
<style>
.intro-text {
  font-family: Calibri, sans-serif;
}
</style>
<script>
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  components: {HeadWithLogo}
}
</script>
